import { render } from "./FourthStep.vue?vue&type=template&id=1d415684&scoped=true"
import script from "./FourthStep.vue?vue&type=script&lang=js"
export * from "./FourthStep.vue?vue&type=script&lang=js"

import "./FourthStep.vue?vue&type=style&index=0&id=1d415684&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d415684"]])

export default __exports__